import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { AuthGuard } from './helpers/auth.guard';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';


export const routes: Routes = [

  {
    path: '404',
    component: P404Component,
  },
  {
    path: '500',
    component: P500Component,
  },
  {
    path: '',
    loadChildren: () => import('./views/admin-login/admin-login.module').then(m => m.AdminLoginModule)
  },
  {
    path: 'privacy',
    loadChildren: () => import('./views/privacy/privacy.module').then(m => m.PrivacyModule)
  },
  
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'settings',
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule)
      },
      {
        path: 'retailer',
        loadChildren: () => import('./views/retailer/retailer.module').then(m => m.RetailerModule)
      },
      {
        path: 'product',
        loadChildren: () => import('./views/product/product.module').then(m => m.ProductModule)
      },
      {
        path: 'category',
        loadChildren: () => import('./views/category/category.module').then(m => m.CategoryModule)
      },
      {
        path: 'sub-category',
        loadChildren: () => import('./views/sub-category/sub-category.module').then(m => m.SubCategoryModule)
      },
      {
        path: 'order',
        loadChildren: () => import('./views/orders/orders.module').then(m => m.OrdersModule)
      }, {
        path: 'template',
        loadChildren: () => import('./views/template/template.module').then(m => m.TemplateModule)
      },
      {
        path: 'unit',
        loadChildren: () => import('./views/unit/unit.module').then(m => m.UnitModule)
      }, {
        path: 'payment',
        loadChildren: () => import('./views/payment-management/payment-management.module').then(m => m.PaymentManagementModule)
      },
      {
        path: 'timeslot',
        loadChildren: () => import('./views/time-slot/time-slot.module').then(m => m.TimeSlotModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./views/notification/notification.module').then(m => m.NotificationModule)
      },
      
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ],
    canActivate: [AuthGuard]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
